
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 293.97 252.88"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"M90.81 181.17A3.11 3.11 0 0087.7 178l-37.75.33a3.09 3.09 0 00-2.84 4.18c3.89 10.75 6.26 21.39 8.34 30.95 4.59 21.15 8.56 39.42 27.83 39.42 15.42 0 26.1-4.46 29.32-12.23 1.39-3.37 2.48-10.25-5.88-18.59-10.85-10.83-16.01-20.69-15.91-40.89zm-78-108.42h-2.22A10.59 10.59 0 000 83.34v59.32a10.59 10.59 0 0010.59 10.59h2.22a2.17 2.17 0 002.18-2.18V74.93a2.17 2.17 0 00-2.18-2.18zm88.66 91.17l2.66.18a6.25 6.25 0 006.67-6.24V70a6.25 6.25 0 00-6.67-6.23l-2.74.18c-4.21.28-8.44.41-12.66.41H54.04c-.64 0-2.9-.12-16.35-.05a11.15 11.15 0 00-10.7 8.47l-.26 80.57a11.11 11.11 0 0011 10.18h50.92q6.44-.03 12.82.39zM249.32 1.17a15.09 15.09 0 00-11.15-.2C213 24.35 171.24 52.48 130.44 61.26a8.22 8.22 0 00-6.61 8v89.34a8.23 8.23 0 006.61 8c40.81 8.8 82.55 37 107.73 60.4a14.87 14.87 0 005.07.93 15.6 15.6 0 006.08-1.24 15.3 15.3 0 009.52-14.32V15.49a15.29 15.29 0 00-9.52-14.32zm26.3 66.06a2.14 2.14 0 00-3.3 1.77v89.8a2.13 2.13 0 003.3 1.8c13.19-9.2 18.34-30.34 18.34-46.68s-5.15-37.48-18.34-46.69z"}})])
          )
        }
      }
    